var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import { Modal } from '@doordash/component-modal';
import { deleteBudget, fetchTeamAccountBudgets } from '../budgets_slice';
import { useSelector, useDispatch } from 'react-redux';
import DeleteFlexBudgetModalContent from './delete_flex_budget_modal_content';
import Button from '@doordash/component-button';
import track from '../../../utils/track';
import { MealBudgetsEvents } from '../../../constants/events';
import { TEAM_ACCOUNT_COUNTRY_CODE } from '../../../types/portal_data';
import { getSelectedTeamAccountContent } from '../../../selectors/uiSelector';
export var DeleteFlexBudgetModal = function (_a) {
    var _b;
    var budget = _a.budget, teamAccountId = _a.teamAccountId, onClose = _a.onClose;
    var dispatch = useDispatch();
    var _c = __read(React.useState(null), 2), errorMessage = _c[0], setErrorMessage = _c[1];
    var _d = __read(React.useState(false), 2), isSubmitting = _d[0], setIsSubmitting = _d[1];
    var teamAccount = useSelector(getSelectedTeamAccountContent);
    var teamAccountCountryCode = (_b = teamAccount.countryCode) !== null && _b !== void 0 ? _b : TEAM_ACCOUNT_COUNTRY_CODE.US;
    var handleDelete = function () {
        setIsSubmitting(true);
        dispatch(deleteBudget(budget.id))
            .unwrap()
            .then(function () {
            dispatch(fetchTeamAccountBudgets({ teamAccountId: teamAccountId, includeGroupsInfo: true }));
            track(MealBudgetsEvents.DELETE_BUDGET, {
                budget_name: budget.name,
                budget_id: budget.id,
            });
            setIsSubmitting(false);
            onClose();
        }, function (errorResponse) {
            setErrorMessage(errorResponse.error || 'There was an error.');
            setIsSubmitting(false);
        });
    };
    return (React.createElement(Modal, { size: Modal.Sizes.Medium, onClose: onClose, title: "Delete Budget", primaryAction: {
            text: 'Delete Budget',
            onClick: function () { return handleDelete(); },
            buttonProps: {
                state: isSubmitting ? Button.States.Loading : Button.States.Default,
                isDisabled: isSubmitting,
            },
        }, secondaryAction: {
            text: 'Cancel',
            onClick: function () { return onClose(); },
        } },
        React.createElement(DeleteFlexBudgetModalContent, { countryCode: teamAccountCountryCode, budget: budget, errorMessage: errorMessage })));
};
export default DeleteFlexBudgetModal;
